import React from 'react'
import { Box } from 'components'

export const LineBreak = () => (
  <Box borderTop='1px solid #e3e3e3' margin='8px 0' height={1} width={1} />
)
